<template>
  <div>
    <!-- [ Modal form Add Task ] start -->
    <sweet-modal :title="stateTask === 'edit' ? $t('modal_editEngagementTask') : $t('modal_addNewEngagementTask')" blocking ref="addTask" class="modal" v-on:close="closeTaskModal">
      <el-form :model="formAddTask" status-icon :rules="rules" ref="formAddTask" class="demo-ruleForm">
        <el-row :gutter="20">
          <el-col :span="24" :offset="0">
            <!-- :label="$t('modal_name')" label-width="100px" -->
            <el-form-item size="mini" prop="taskName">
              <el-input :label="$t('modal_taskName')" v-model="formAddTask.taskName"></el-input>
          </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12" :offset="0">
            <!-- :label="$t('modal_taskType')" label-width="100px" -->
            <el-form-item size="mini" v-if="stateTask === 'add' || stateTask === 'insert'" prop="typeTaskId">
              <el-select no-data-text="no date" v-model="formAddTask.typeTaskId" :placeholder="$t('modal_taskType')" style="width:100%;">
                <el-option
                  v-for="item in formAddTask.typeTask"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                  @click.native="handleTaskFunctions('getTaskFunctionList', item.id)">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="0">
            <!-- :label="$t('modal_function')" label-width="100px" -->
            <el-form-item size="mini" v-if="stateTask === 'add' || stateTask === 'insert'" prop="functionTaskId">
              <el-select no-data-text="no date" v-model="formAddTask.functionTaskId" :placeholder="$t('modal_taskFunction')" style="width:100%;">
                <el-option
                  v-for="item in formAddTask.functionTask"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12" :offset="0">

            <el-row :gutter="20">
              <el-col :span="12" :offset="0">
                <el-form-item size="mini" prop="plannedStartDate">
                  <el-date-picker
                    v-model="formAddTask.plannedStartDate"
                    type="datetime"
                    format="d MMM yy h:mm a"
                    value-format="timestamp"
                    :placeholder="$t('modal_startDate')"
                    :picker-options="pickerOptions2"
                    style="width: 100%;">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12" :offset="0">
                <el-form-item size="mini" prop="reviewDate">
                  <el-date-picker
                    v-model="formAddTask.reviewDate"
                    type="datetime"
                    format="d MMM yy h:mm a"
                    value-format="timestamp"
                    :placeholder="$t('modal_reviewDate')"
                    style="width: 100%;">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

          </el-col>
          <el-col :span="12" :offset="0">

            <el-form-item size="mini" prop="companyStageId">
              <el-select v-model="formAddTask.companyStageId" :placeholder="$t('modal_stage')" style="width: 100%">
                <el-option
                  v-for="item in formAddTask.companyStageList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>

          </el-col>
        </el-row>


        <el-row :gutter="20">
          <el-col :span="12" :offset="0">
            <br>
          </el-col>
          <el-col :span="12" :offset="0">
            <!-- :label="$t('modal_taskPriority')" label-width="100px" -->
            <el-form-item size="mini" prop="taskPriorityId">
              <el-select v-model="formAddTask.taskPriorityId" :placeholder="$t('modal_taskPriority')" style="width:100%;">
                <el-option
                  v-for="priority in formAddTask.taskPriority"
                  :key="priority.id"
                  :label="priority.name"
                  :value="priority.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="aboutButton">
          <el-button style="width: 100%;" class="btn-wrap" slot="button" v-on:click="$refs.nestedChild.open()" size="medium" type="primary" plain>{{$t('modal_aboutThisTask')}}</el-button>
        </div>

        <el-row :gutter="20">
          <el-col :span="12" :offset="0">
            <el-form-item size="mini">
              <el-switch active-color="#13ce66" v-model="formAddTask.progressNote" :disabled="addProgDisabled || editDisabled && taskStatus !== 1"></el-switch> {{$t('modal_addProgressNote')}}
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="0"></el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12" :offset="0">
            <!-- :label="$t('modal_reoccuringTask')" label-width="120px" -->
            <el-form-item size="mini" prop="reoccuringTask">
              <el-switch active-color="#13ce66" v-model="formAddTask.reoccuringTask" :disabled="isEditActivated && taskStatus !== 1 || (formAddTask.deadline && !formAddTask.reoccuringTask)"></el-switch> {{$t('modal_reoccuringTask')}}
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="0"></el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12" :offset="0">
            <!-- :label="$t('modal_setDeadline')" label-width="120px" -->
            <el-form-item size="mini">
              <el-switch active-color="#13ce66" v-model="formAddTask.deadline" :disabled="isEditActivated && taskStatus !== 1 || (!formAddTask.deadline && formAddTask.reoccuringTask)"></el-switch> {{$t('modal_setDeadline')}}
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="0"></el-col>
        </el-row>

        <el-row :gutter="20" v-if="formAddTask.deadline">
          <el-col :span="12" :offset="0">
            <!-- :label="$t('modal_endedDate')" label-width="95px" -->
            <el-form-item size="mini">
              <el-date-picker
                v-model="formAddTask.endedDate"
                type="datetime"
                style="width:100%;"
                :placeholder="$t('modal_endedDate')"
                format="d MMM yy h:mm a"
                value-format="timestamp">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12"></el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12" :offset="0">
            <!-- :label="$t('modal_repeatTask')" label-width="190px" -->
            <el-form-item size="mini" v-if="formAddTask.reoccuringTask" prop="daysCount">
              <!--<el-select v-model="changeDayOrHour">-->
                  <!--<el-option v-for="item in changeDayOrHourList"-->
                              <!--:key="item.value"-->
                              <!--:label="item.label"-->
                              <!--:value="item.value">-->
                  <!--</el-option>-->
              <!--</el-select>-->

              <el-input type="number" v-model="formAddTask.daysCount" :label="$t('modal_repeatTask')" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="0">
            <!-- :label="$t('modal_startDay')" label-width="95px" -->
            <el-form-item size="mini" v-if="formAddTask.reoccuringTask" prop="startDay">
              <el-date-picker
                format="d MMM yy h:mm a"
                v-model="formAddTask.startDay"
                type="datetime"
                style="width: 100%;"
                :placeholder="$t('modal_startDay')"
                value-format="timestamp">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20" v-if="formAddTask.reoccuringTask">
          <el-col :span="24" :offset="0">
            <!-- :label="$t('modal_numberOfRepetitions')" label-width="190px" -->
            <el-form-item size="mini" prop="reocuringCounter">
              <el-radio @change="cangedReocuringCount" v-model="formAddTask.reocuringCount" :label="false">{{$t('modal_numberOfRepetitions_infinitely')}}</el-radio>
              <el-radio v-model="formAddTask.reocuringCount" :label="true">{{$t('modal_numberOfRepetitions_setNumber')}}</el-radio>
              <el-input size="mini" v-if="formAddTask.reocuringCount" type="number" v-model="formAddTask.reocuringCounter" class="input-recuring-counter"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12" :offset="0">
            <!-- :label="$t('modal_team')" label-width="100px" -->
            <el-form-item size="mini">
              <treeselect
                :multiple="true"
                :placeholder="$t('modal_team')"
                :options="formAddTask.taskTeam"
                :disable-branch-nodes="true"
                v-model="formAddTask.taskTeamId"
                :beforeClearAll="beforeClearAll"
                @deselect="deselect"
                search-nested
              />
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="0">
            <!--IF REOCCURING CHECKED-->
            <!-- :label="$t('modal_leader')" label-width="100px" -->
            <el-form-item size="mini" v-if="formAddTask.reoccuringTask" prop="assignedToId">
              <el-select v-model="formAddTask.assignedToId" :placeholder="$t('modal_assignedTo')" style="width:100%;">
                <el-option
                  v-for="assign in assignedToList"
                  :key="assign.id"
                  :label="assign.user.fullName"
                  :value="assign.id"
                  :class="{ disabled: assign.status != 1 }"
                  @click.native="handleSelectLeader(assign.id)"></el-option>
              </el-select>
            </el-form-item>
            <!--IF REOCCURING NOT CHECKED-->
            <!-- :label="$t('modal_leader')" label-width="100px" -->
            <el-form-item size="mini" v-else prop="assignedToIdNoComp">
              <el-select clearable v-model="formAddTask.assignedToId" :placeholder="$t('modal_assignedTo')" style="width:100%;">
                <el-option
                  v-for="assign in assignedToList"
                  :key="assign.id"
                  :label="assign.user.fullName"
                  :value="assign.id"
                  :class="{ disabled: assign.status != 1 }"
                  @click.native="handleSelectLeader(assign.id)"></el-option>
              </el-select>
            </el-form-item>
            <!-- :label="$t('modal_businessUnit')" label-width="100px" -->
            <el-form-item size="mini" v-if="formAddTask.assignedToId" prop="businessUnitId">
              <el-radio-group v-model="formAddTask.businessUnitId">
                <el-row v-for="businessUnit in formAddTask.businessUnitList" :key="businessUnit.id">
                  <el-radio :label="businessUnit.id">{{businessUnit.name}}</el-radio>
                </el-row>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12" :offset="0">
            <!-- :label="$t('modal_clients')" label-width="100px" -->
            <el-form-item size="mini" prop="projectClientListId">
              <el-select no-data-text="no date" v-model="formAddTask.clientsId" multiple :placeholder="$t('modal_engagementClients')" style="width:100%;">
                <el-option-group
                  class="select-group"
                  @click.native="ggg(group)"
                  v-for="group in newClientList"
                  :key="group.companyClientId"
                  :label="group.companyClient.name">
                  <el-option
                    v-for="item in group.people"
                    :key="item.id"
                    :label="item.fullName"
                    :value="item.id">
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="0">
            <el-form-item size="mini">
              <el-switch active-color="#13ce66" v-model="formAddTask.allowExternalNotification"></el-switch> {{$t('modal_allowClientVendorNotifications')}}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12" :offset="0">
            <!-- :label="$t('modal_vendors')" label-width="100px" -->
            <el-form-item size="mini" prop="projectVendorListId">
              <el-select v-model="formAddTask.vendorsId" :placeholder="$t('modal_engagementVendors')" multiple style="width:100%;">
                <el-option-group
                  class="select-group"
                  @click.native="ggg(group)"
                  v-for="group in newVendorList"
                  :key="group.companyVendorId"
                  :label="group.companyVendor.name">
                  <el-option
                    v-for="item in group.people"
                    :key="item.id"
                    :label="item.fullName"
                    :value="item.id">
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="0">
            <el-form-item size="mini">
              <el-switch active-color="#13ce66" v-model="formAddTask.addTaskDocuments"></el-switch> {{$t('modal_addTaskDocuments')}}
            </el-form-item>
          </el-col>
        </el-row>

        <!-- DM -->
        <el-row :gutter="20" v-if="formAddTask.addTaskDocuments">
          <el-col :span="12" :offset="0">
            <!-- :label="$t('modal_sop')" label-width="100px" -->
            <el-form-item size="mini">
              <el-select v-model="formAddTask.sopListId" :placeholder="$t('modal_sop')" clearable style="width:100%;">
                <el-option v-for="item in formAddTask.sopList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="0">
            <!-- :label="$t('modal_policy')" label-width="100px" -->
            <el-form-item size="mini">
              <el-select v-model="formAddTask.policyListId" :placeholder="$t('modal_policy')" clearable style="width:100%;">
                <el-option v-for="item in formAddTask.policyList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20" v-if="formAddTask.addTaskDocuments">
          <el-col :span="12" :offset="0">
            <!-- :label="$t('modal_healthSafety')" label-width="100px" -->
            <el-form-item size="mini">
              <el-select v-model="formAddTask.healthSafetyListId" :placeholder="$t('modal_healthSafety')" clearable style="width:100%;">
                <el-option v-for="item in formAddTask.healthSafetyList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="0">
            <!-- :label="$t('modal_commercial')" label-width="100px" -->
            <el-form-item size="mini">
              <el-select v-model="formAddTask.riskAssesmentListId" :placeholder="$t('modal_commercial')" clearable style="width:100%;">
                <el-option v-for="item in formAddTask.riskAssesmentList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20" v-if="formAddTask.addTaskDocuments">
          <el-col :span="12" :offset="0">
            <!-- :label="$t('modal_general')" label-width="100px" -->
            <el-form-item size="mini">
              <el-select v-model="formAddTask.envirenmentalListId" :placeholder="$t('modal_general')" clearable style="width:100%;">
                <el-option v-for="item in formAddTask.envirenmentalList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="0"></el-col>
        </el-row>

        <div class="flex-end" v-if="stateTask === 'add'">
          <el-form-item>
            <el-button size="medium" @click="modalCancel('addTask')">{{$t('general_cancel')}}</el-button>
            <el-button size="medium" @click="addTaskSubmit('formAddTask')" class="modal__btn" type="primary">{{$t('general_submit')}}</el-button>
          </el-form-item>
        </div>
        <div class="flex-end" v-else-if="stateTask === 'edit'">
          <el-form-item>
            <el-button size="medium" @click="modalCancel('addTask')">{{$t('general_cancel')}}</el-button>
            <el-button size="medium" @click="editTaskSubmit('formAddTask')" class="modal__btn" type="primary">{{$t('general_submit')}}</el-button>
          </el-form-item>
        </div>
        <div class="flex-end" v-else-if="stateTask === 'insert'">
          <el-form-item>
            <el-button size="medium" @click="modalCancel('addTask')">{{$t('general_cancel')}}</el-button>
            <el-button size="medium" @click="insertTaskSubmit('formAddTask')" class="modal__btn" type="primary">{{$t('general_submit')}}</el-button>
          </el-form-item>
        </div>

      </el-form>
    </sweet-modal>
    <!-- [ Modal form Add Task ] end -->

    <sweet-modal blocking ref="nestedChild">
      <vue2-custom-editor
          ref="editor"
          :placeholder="$t('modal_aboutThisTask')"
          v-model="formAddTask.aboutThisTask"
          style="margin-bottom: 20px;">
      </vue2-custom-editor>
      <!--<el-input type="textarea" placeholder="About this task" v-model="formAddTask.aboutThisTask"></el-input>-->
      <!-- <el-button slot="button" v-on:click="$refs.nestedChild.close()">{{$t('general_ok')}}</el-button> -->
      <div class="modal__btn">
        <el-button slot="button" v-on:click="$refs.nestedChild.close()" type="primary">{{$t('general_ok')}}</el-button>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
  import axios from 'axios';
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue';
  import moment from 'moment'
  import Treeselect from '@riophae/vue-treeselect'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  import Vue2CustomEditor from "../vue-2-custom-editor";


  export default {
    name: "CreateEngagementTaskModal",
    components:{
      Vue2CustomEditor,
      SweetModal,
      Treeselect
    },
    computed:{
      reoccuringTask(){
        return this.formAddTask.reoccuringTask
      },
      assignedToList() {
        const list = []
        this.formAddTask.taskTeamId.forEach(memberId => {
          const doctor = this.formAddTask.assignedTo.find(item => item.id === memberId)
          list.push(doctor)
        })
        return list
      }
    },
    props:['selectedRow'],
    data(){
      var checkRepeatTask = (rule, value, callback) => {
        if (!value && this.addProgDisabled) {
          return callback(new Error('Please input the field'));
        }else if(value == 0 && this.addProgDisabled){
          return callback(new Error('Repeat task interval cant be 0'));
        }else callback();
      }
      var checkStartDay = (rule, value, callback) => {
        if (!value && this.addProgDisabled) {
          return callback(new Error('Please input the field'));
        }else callback();
      };
      var checkNumberOfRepetitions = (rule, value, callback) => {
        if (!value && this.formAddTask.reocuringCount) {
          return callback(new Error('Please input the field'));
        }else if(value == 0 && this.formAddTask.reocuringCount){
          return callback(new Error('Number of repetitions cant be 0'));
        }else callback();
      };
      return{
        isEditActivated: false,
        stateTask: '',
        newClientList: [],
        newVendorList: [],
        businessUnits: [],
        companyUserList: [],
        addProgDisabled: false,
        editDisabled: false,
        changeDayOrHourList: [{
          label: "Days",
          value: 1
        }],
        changeDayOrHour: 1,
        formAddTask: {
          companyStageId: null,
          companyStageList: [],
          plannedStartDate: null,
          reviewDate: null,

          // plannedStartDate: 0,
          // reviewDate: 0,
          deadline: false,
          endedDate: null,
          taskName: '',
          functionTaskId: '',
          functionTask: [],
          typeTask: '',
          typeTaskId: '',
          taskTeam: [],
          taskTeamId: [],
          reoccuringTask:false,
          reocuringCount:false,
          reocuringCounter: 1,
          aboutThisTask: '',
          daysCount: 1,
          taskPriorityId: '',
          taskPriority: [],
          assignedTo: [],
          assignedToId: null,
          businessUnitId: null,
          businessUnitList: null,
          progressNote: false,
          timeSheet: false,
          addTaskDocuments: false,
          allowExternalNotification: false,
          startDay: '',
          clients: '',
          clientsId:[],
          vendors: '',
          vendorsId:[],

          // DM
          sopList: [],
          sopListId: null,
          policyList: [],
          policyListId: null,
          healthSafetyList: [],
          healthSafetyListId: null,
          riskAssesmentList: [],
          riskAssesmentListId: null,
          envirenmentalList: [],
          envirenmentalListId: null,
        },
        pickerOptions2: {
          disabledDate: this.disabledDueDate,
        },
        minimumDate: null,
        rules: {
          taskName: [
            { required: true, message: 'Please input Task name', trigger: 'blur' }
          ],
          typeTaskId: [
            { required: true, message: 'Please select Task Type', trigger: 'change' }
          ],
          taskPriorityId:[
            { required: true, message: 'Please select Task Priority', trigger: 'change' }
          ],
          assignedToId: [
            { required: true, message: 'Please Assigned To', trigger: 'change' }
          ],
          functionTaskId:[
            { required: true, message: 'Please pick a Task Function', trigger: 'blur' }
          ],
          businessUnitId: [
            { required: true, message: 'Please select Business Unit', trigger: 'blur' }
          ],
          companyStageId:[
            { required: true, message: 'Field is required', trigger: 'change' }
          ],
          // plannedStartDate: [
          //   { required: true, message: 'Field is required', trigger: 'blur' }
          // ],
          // reviewDate: [
          //   { required: true, message: 'Field is required', trigger: 'blur' }
          // ],
          daysCount: [{ validator: checkRepeatTask, trigger: 'blur' }],
          startDay: [{ validator: checkStartDay, trigger: 'blur' }],
          reocuringCounter: [{ validator: checkNumberOfRepetitions, trigger: 'blur' }]
        },
        taskStatus: 1
      }
    },
    methods: {
      openModal(state){
        let loader = this.$loading.show();
        this.stateTask = state;
        let operation = '';
        if(state === 'add'){
          operation = 'create'
        }else if(state === 'edit'){
          operation = 'update'
        }else if (state === 'insert'){
          operation = 'create'
        }
        console.log('---', 'add');
        this.$refs.addTask.open();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/engagementTasks/directories?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}&operation=${operation}`)
          .then(response => {
            if (response.data.success) {
              console.log("getEngagementDir", response.data);

              let result = [];
              for (let index = 0; index < response.data.businessUnitList.length; index++) {
                let businessUnit = response.data.businessUnitList[index];
                let children = [];
                for (let index2 = 0; index2 < response.data.companyUserList.length; index2++) {
                  let companyUser = response.data.companyUserList[index2];
                  if (companyUser.businessUnitId == businessUnit.id) {
                    children.push({
                      id: companyUser.id,
                      label: companyUser.user.fullName,
                      status: companyUser.status
                    })
                  }
                }

                result.push({
                  id: businessUnit.name,
                  label: businessUnit.name,
                  children: children,
                })
              }

              this.formAddTask.companyStageList = response.data.companyStageList


              this.formAddTask.taskTeam = result

              this.businessUnits = response.data.businessUnitList
              this.companyUserList = response.data.companyUserList


              this.formAddTask.taskPriority = response.data.priorityList
              this.formAddTask.typeTask = response.data.taskTypeList
              this.formAddTask.assignedTo = response.data.companyUserList.filter((thing, index, self) =>
                index === self.findIndex((t) => (
                  t.id === thing.id
                ))
              );
              // this.formAddTask.taskTeam = response.data.companyUserList
              // this.formAddTask.clients = response.data.companyClientList
              // this.formAddTask.vendors = response.data.companyVendorList

              // DM
              this.formAddTask.sopList = response.data.sopList
              this.formAddTask.policyList = response.data.policyList
              this.formAddTask.healthSafetyList = response.data.healthSafetyList
              this.formAddTask.riskAssesmentList = response.data.riskAssesmentList
              this.formAddTask.envirenmentalList = response.data.envirenmentalList

              this.newVendorList = this.createMyList(response.data.companyVendorList, response.data.companyVendorPersonList, 'vendors')
              this.newClientList = this.createMyList(response.data.companyClientList, response.data.companyClientPersonList, 'clients')

              // handle eng plannedStart day
              // if (response.data.plannedStartDate) {
              //   if (response.data.plannedStartDate.toString().length < 8) {
              //     this.minimumDate = '0' + response.data.plannedStartDate.toString()
              //   } else {
              //     this.minimumDate = response.data.plannedStartDate.toString()
              //   }
              // }
              this.minimumDate = response.data.plannedStartDate || null

              if(state === 'add' || state === 'insert'){
                loader.hide()
              }
              this.$nextTick(() => {
                this.$refs.editor.setImagesState()
              })
            }
            if(state === "edit"){
              this.isEditActivated = true
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              axios.post(`/api/v1/engagementTasks/item?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}&engagementTaskId=${this.selectedRow.id}`)
                .then(response => {
                  if (response.data.success){

                    // let start = null
                    // if (response.data.item.dateData.plannedStartDate) {
                    //   start = response.data.item.dateData.plannedStartDate.toString();
                    //   if (start.length < 8) {
                    //     start = '0' + start
                    //   }
                    // }

                    // let review = null
                    // if (response.data.item.dateData.reviewDate) {
                    //   review = response.data.item.dateData.reviewDate.toString();
                    //   if (review.length < 8) {
                    //     review = '0' + review
                    //   }
                    // }


                    this.formAddTask.plannedStartDate = response.data.item.plannedStartDate
                    this.formAddTask.reviewDate = response.data.item.reviewDate

                    console.log("EDIT TASK", response.data);
                    if(response.data.item.isReoccurring === 1){
                      this.formAddTask.reoccuringTask = true
                    }else{
                      this.formAddTask.reoccuringTask = false
                    }
                    if(response.data.item.hasProgress === 1){
                      this.formAddTask.progressNote = true
                      this.editDisabled = true
                    }else{
                      this.formAddTask.progressNote = false
                    }
                    this.formAddTask.taskName = response.data.item.name
                    this.formAddTask.aboutThisTask = response.data.item.description
                    this.formAddTask.taskPriorityId = response.data.item.priorityId
                    if(response.data.item.repeatTaskInterval % 24 === 0){
                      this.formAddTask.daysCount = response.data.item.repeatTaskInterval / 24
                      this.changeDayOrHour = 1
                    }else{
                      this.formAddTask.daysCount = response.data.item.repeatTaskInterval
                      this.changeDayOrHour = 2
                    }
                    if(response.data.item.recurringCount !== -1 ){
                      this.formAddTask.reocuringCount = true
                      this.formAddTask.reocuringCounter = response.data.item.recurringCount
                    }else{
                      this.formAddTask.reocuringCount = false
                    }
                    if(response.data.item.allowExternalNotifications === 1){
                      this.formAddTask.allowExternalNotification = true
                    }else{
                      this.formAddTask.allowExternalNotification = false
                    }
                    // this.formAddTask.allowExternalNotification = response.data.item.allowExternalNotifications
                    this.formAddTask.clientsId = response.data.item.companyClientPersonIdList
                    this.formAddTask.vendorsId = response.data.item.companyVendorPersonIdList
                    this.formAddTask.typeTaskId = response.data.item.taskTypeId
                    this.formAddTask.assignedToId = response.data.item.leaderCompanyUserId

                    this.formAddTask.companyStageId = response.data.item.companyStageId

                    // get bu ids of that user start
                    const buIds = this.companyUserList.filter(val => val.id === response.data.item.leaderCompanyUserId);
                    const businessUnitList = [];
                    if (buIds.length) {
                      buIds.forEach(val => {
                        const bu = this.businessUnits.filter(bu => bu.id === val.businessUnitId)[0];
                        businessUnitList.push(bu)
                      });
                    }
                    this.formAddTask.businessUnitList = businessUnitList;
                    // get bu ids of that user end

                    this.formAddTask.businessUnitId = response.data.item.businessUnitId
                    this.formAddTask.taskTeamId = response.data.item.companyUserIdList
                    this.formAddTask.startDay = response.data.item.reoccuringStartDate * 1000
                    this.formAddTask.addTaskDocuments = !!response.data.item.addTaskDocument

                    // DM
                    this.formAddTask.sopListId = response.data.item.sopId
                    this.formAddTask.policyListId = response.data.item.policyId
                    this.formAddTask.healthSafetyListId = response.data.item.healthSafetyId
                    this.formAddTask.riskAssesmentListId = response.data.item.riskAssesmentId
                    this.formAddTask.envirenmentalListId = response.data.item.envirenmentalId

                    if (response.data.item.deadline) {
                      this.formAddTask.deadline = response.data.item.deadline
                      this.formAddTask.endedDate = response.data.item.deadlineDate
                    }

                    this.taskStatus = response.data.item.status
                    loader.hide()
                    this.$nextTick(() => {
                      this.$refs.editor.setImagesState()
                    })
                  }
                })
                .catch(error => {
                  this.notification("Notification", error.response.data.message, "info")
                  loader.hide();
                  console.log('An error occurred:', error);
                });
            }
          })
          .catch(error => {
            loader.hide();
            console.log('An error occurred:', error);
          });
      },
      disabledDueDate (time) {
        // console.log(Number(moment(this.minimumDate, 'DDMMYYYY').format('x')));
        // console.log(Date.now());
        // console.log('ma time', time)
        if (this.minimumDate) {
          let start = time.getTime() < this.minimumDate
          // let start = time.getTime() < Number(moment(this.minimumDate, 'DDMMYYYY').format('x'));
          if (start){
            return start
          }
        }
      },
      createMyList(list, personList, state) {
        console.log('list, personList, state', list, personList, state)
        const myList = []

        for (let i = 0; i < list.length; i++) {
          myList.push({ ...list[i], people: [] })
          if(state === 'vendors'){
            for (let j = 0; j < personList.length; j++) {
              if (list[i].companyVendorId === personList[j].companyVendorId) {
                myList[i].people.push(personList[j])
                // personList.splice(j, 1)
              }
            }
          }
          if(state === 'clients'){
            for (let j = 0; j < personList.length; j++) {
              if (list[i].companyClientId === personList[j].companyClientId) {
                myList[i].people.push(personList[j])
                // personList.splice(j, 1)
              }
            }
          }
        }
        console.log('myList11', myList)
        return myList
      },
      handleTaskFunctions(state, id) {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/engagementTasks/directories?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}&operation=${state}&taskTypeId=${id}`)
          .then(response => {
            console.log(response)
            this.formAddTask.functionTask = response.data.taskFunctionList
            loader.hide()
          })
          .catch(error => {
            this.notification("Notification", error.response.data.message, "info")
            console.log('An error occurred:', error);
            loader.hide()
            loader.hide()
          })
      },
      deselect(node, instanceId){
        if (this.formAddTask.assignedToId === node.id) {
          this.formAddTask.assignedToId = null;
          this.formAddTask.businessUnitId = null;
          this.formAddTask.businessUnitList = []
        }
      },
      beforeClearAll(){
        // CLEAR LEADER IF DELETE ALL TEAM
        if (this.formAddTask.assignedToId) {
          this.formAddTask.assignedToId = null;
          this.formAddTask.businessUnitId = null;
          this.formAddTask.businessUnitList = []
        }
        return true
      },
      cangedReocuringCount(val){
        this.$refs['formAddTask'].clearValidate('reocuringCounter')
      },
      handleSelectLeader(leaderId){
        const even = (element) => element === leaderId;
        const ifUserInTeam = this.formAddTask.taskTeamId.some(even);
        if (!ifUserInTeam) {
          this.formAddTask.taskTeamId.push(leaderId)
        }
        this.formAddTask.businessUnitList = [];
        // get all bu ids which added to that user
        const ids = [];
        this.companyUserList.forEach(val =>{
          if(val.id === leaderId){
            ids.push(val.businessUnitId)
          }
        });
        // get all bu by current user
        ids.forEach(id => {
          this.businessUnits.forEach(bu => {
            if (id === bu.id) this.formAddTask.businessUnitList.push(bu)
          })
        });
        this.formAddTask.businessUnitList.sort(function(a, b){
          if(a.name < b.name) { return -1; }
          if(a.name > b.name) { return 1; }
          return 0;
        })
      },
      ggg(value) {
        console.log(value)
      },
      addTaskSubmit(form) {
        console.log('SELECTED ROW Type', this.selectedRow.type);
        if (this.selectedRow.type === "Engagement"){
          this.engagementTaskId = null;
        }else{
          this.engagementTaskId = this.selectedRow.id;
        }
        this.$refs[form].validate((valid) => {
          if (valid) {
            let currentTime = Number(moment().format('X'))
            let startDay = this.formAddTask.startDay
            let daysCount = this.formAddTask.daysCount


            if (!this.formAddTask.reoccuringTask) {
              startDay = null
              daysCount = null
            } else {
              startDay = this.formAddTask.startDay / 1000
              if (this.changeDayOrHour == 1) {
                daysCount = this.formAddTask.daysCount * 24
              } else {
                daysCount = this.formAddTask.daysCount
              }

              const whenTaskStart = Number(moment(startDay, 'X').add(daysCount, 'hours').format('X'))

              if(this.formAddTask.reoccuringTask && currentTime > whenTaskStart){
                return this.$alert('<div>' + this.$t('notification_recurringStartDateCanOnlyBeBackDatedInlineWithTheFirstRecurringPeriod') + '</div>' + '<div>' + this.$t('notification_currentDate30thJun21RecurringDaysIs7RecurringStartDateCanOnlyBeBackDatedTo23rdJun21WhichisWithInOneRecurringPeriod') + '</div>', this.$t('notification_tfSupport'), {
                  confirmButtonText: 'Close',
                  dangerouslyUseHTMLString: true,
                  customClass: 'support-alert',
                  callback: action => {
                    console.log('action', action)
                  }
                });
              }
            }

            if (!this.formAddTask.addTaskDocuments) {
              this.formAddTask.sopListId = null
              this.formAddTask.policyListId = null
              this.formAddTask.healthSafetyListId = null
              this.formAddTask.riskAssesmentListId = null
              this.formAddTask.envirenmentalListId = null
            }
            const data = {
              name: this.formAddTask.taskName,
              description: this.formAddTask.aboutThisTask,
              priorityId: this.formAddTask.taskPriorityId,
              isReoccurring: this.formAddTask.reoccuringTask,
              repeatTaskInterval: daysCount || null,
              recuringCount: !this.formAddTask.reocuringCount ? -1 : this.formAddTask.reocuringCounter,
              parentEngagementTaskId: this.engagementTaskId,
              leaderCompanyUserId: this.formAddTask.assignedToId || null,
              businessUnitId: this.formAddTask.businessUnitId,
              hasProgress: this.formAddTask.progressNote,
              allowExternalNotifications: this.formAddTask.allowExternalNotification,
              companyClientPersonIdList: this.formAddTask.clientsId,
              companyVendorPersonIdList: this.formAddTask.vendorsId,
              taskTypeId: this.formAddTask.typeTaskId,
              companyUserIdList: this.formAddTask.taskTeamId,
              reoccuringStartDate: startDay || null,
              taskFunctionId: this.formAddTask.functionTaskId,
              addTaskDocument: this.formAddTask.addTaskDocuments,
              // DM
              sopId: this.formAddTask.sopListId,
              policyId: this.formAddTask.policyListId,
              healthsafetyId: this.formAddTask.healthSafetyListId,
              riskAssesmentId: this.formAddTask.riskAssesmentListId,
              envirenmentalId: this.formAddTask.envirenmentalListId,

              deadline: this.formAddTask.deadline,
              endedDate: this.formAddTask.endedDate,

              companyStageId: this.formAddTask.companyStageId,
              plannedStartDate: this.formAddTask.plannedStartDate,
              reviewDate: this.formAddTask.reviewDate,
            }
            let loader = this.$loading.show();
            axios
              .post(`/api/v1/engagementTasks/create?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}`, data)
              .then(response => {
                this.$emit('submit', Number(this.$route.query.engagementId), 'created', response.data.engagementTaskId, this.formAddTask.reoccuringTask)
                this.$refs.addTask.close();
                this.notification("Success", "Add task", "success");
                loader.hide()
                if (this.$refs.editor.uploadedImagesArray.length) {
                  this.$store.dispatch('approveUploadedImages', {
                    fileUrlArr: this.$refs.editor.uploadedImagesArray,
                    entityId: response.data.engagementTaskId,
                    entityTypeId: 34 // eng task about entity
                  })
                }
              })
              .catch(error => {
                loader.hide()
                // Handle error.
              });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      insertTaskSubmit(form) {
        if (this.selectedRow.type === "Engagement"){
          this.engagementTaskId = null;
        }else{
          this.engagementTaskId = this.selectedRow.id;
        }
        this.$refs[form].validate((valid) => {
          if (valid) {
            let currentTime = Number(moment().format('X'))
            let startDay = this.formAddTask.startDay
            let daysCount = this.formAddTask.daysCount


            if (!this.formAddTask.reoccuringTask) {
              startDay = null
              daysCount = null
            } else {
              startDay = this.formAddTask.startDay / 1000
              if (this.changeDayOrHour == 1) {
                daysCount = this.formAddTask.daysCount * 24
              } else {
                daysCount = this.formAddTask.daysCount
              }

              const whenTaskStart = Number(moment(startDay, 'X').add(daysCount, 'hours').format('X'))

              if(this.formAddTask.reoccuringTask && currentTime > whenTaskStart){
                return this.$alert('<div>' + this.$t('notification_recurringStartDateCanOnlyBeBackDatedInlineWithTheFirstRecurringPeriod') + '</div>' + '<div>' + this.$t('notification_currentDate30thJun21RecurringDaysIs7RecurringStartDateCanOnlyBeBackDatedTo23rdJun21WhichisWithInOneRecurringPeriod') + '</div>', this.$t('notification_tfSupport'), {
                  confirmButtonText: 'Close',
                  dangerouslyUseHTMLString: true,
                  customClass: 'support-alert',
                  callback: action => {
                    console.log('action', action)
                  }
                });
              }
            }

            if (!this.formAddTask.addTaskDocuments) {
              this.formAddTask.sopListId = null
              this.formAddTask.policyListId = null
              this.formAddTask.healthSafetyListId = null
              this.formAddTask.riskAssesmentListId = null
              this.formAddTask.envirenmentalListId = null
            }
            const data = {
              name: this.formAddTask.taskName,
              description: this.formAddTask.aboutThisTask,
              priorityId: this.formAddTask.taskPriorityId,
              isReoccurring: this.formAddTask.reoccuringTask,
              repeatTaskInterval: daysCount || null,
              recuringCount: !this.formAddTask.reocuringCount ? -1 : this.formAddTask.reocuringCounter,
              parentEngagementTaskId: this.selectedRow.parentEngagementTaskId,
              leaderCompanyUserId: this.formAddTask.assignedToId || null,
              businessUnitId: this.formAddTask.businessUnitId,
              hasProgress: this.formAddTask.progressNote,
              allowExternalNotifications: this.formAddTask.allowExternalNotification,
              companyClientPersonIdList: this.formAddTask.clientsId,
              companyVendorPersonIdList: this.formAddTask.vendorsId,
              taskTypeId: this.formAddTask.typeTaskId,
              companyUserIdList: this.formAddTask.taskTeamId,
              reoccuringStartDate: startDay || null,
              taskFunctionId: this.formAddTask.functionTaskId,
              addTaskDocument: this.formAddTask.addTaskDocuments,
              // DM
              sopId: this.formAddTask.sopListId,
              policyId: this.formAddTask.policyListId,
              healthsafetyId: this.formAddTask.healthSafetyListId,
              riskAssesmentId: this.formAddTask.riskAssesmentListId,
              envirenmentalId: this.formAddTask.envirenmentalListId,

              deadline: this.formAddTask.deadline,
              endedDate: this.formAddTask.endedDate,

              companyStageId: this.formAddTask.companyStageId,
              plannedStartDate: this.formAddTask.plannedStartDate,
              reviewDate: this.formAddTask.reviewDate,
            }
            let loader = this.$loading.show();
            axios
              .post(`/api/v1/engagementTasks/insert?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}&orderIndex=${this.selectedRow.orderIndex}`, data)
              .then(response => {
                this.$emit('submit', Number(this.$route.query.engagementId) ,'created', response.data.engagementTaskId, this.formAddTask.reoccuringTask);
                this.$refs.addTask.close();
                this.notification("Success", "Add task", "success");
                loader.hide()
                if (this.$refs.editor.uploadedImagesArray.length) {
                  this.$store.dispatch('approveUploadedImages', {
                    fileUrlArr: this.$refs.editor.uploadedImagesArray,
                    entityId: response.data.engagementTaskId,
                    entityTypeId: 34 // eng task about entity
                  })
                }
              })
              .catch(error => {
                loader.hide()
                // Handle error.
              });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      editTaskSubmit(form) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            let currentTime = Number(moment().format('X'))
            let startDay = this.formAddTask.startDay
            let daysCount = this.formAddTask.daysCount


            if (!this.formAddTask.reoccuringTask) {
              startDay = null
              daysCount = null
            } else {
              startDay = this.formAddTask.startDay / 1000
              if (this.changeDayOrHour == 1) {
                daysCount = this.formAddTask.daysCount * 24
              } else {
                daysCount = this.formAddTask.daysCount
              }

              const whenTaskStart = Number(moment(startDay, 'X').add(daysCount, 'hours').format('X'))

              if(this.formAddTask.reoccuringTask && currentTime > whenTaskStart){
                return this.$alert('<div>' + this.$t('notification_recurringStartDateCanOnlyBeBackDatedInlineWithTheFirstRecurringPeriod') + '</div>' + '<div>' + this.$t('notification_currentDate30thJun21RecurringDaysIs7RecurringStartDateCanOnlyBeBackDatedTo23rdJun21WhichisWithInOneRecurringPeriod') + '</div>', this.$t('notification_tfSupport'), {
                  confirmButtonText: 'Close',
                  dangerouslyUseHTMLString: true,
                  customClass: 'support-alert',
                  callback: action => {
                    console.log('action', action)
                  }
                });
              }
            }
            if (!this.formAddTask.addTaskDocuments) {
              this.formAddTask.sopListId = null
              this.formAddTask.policyListId = null
              this.formAddTask.healthSafetyListId = null
              this.formAddTask.riskAssesmentListId = null
              this.formAddTask.envirenmentalListId = null
            }

            let loader = this.$loading.show();
            let data ={
              name: this.formAddTask.taskName,
              description: this.formAddTask.aboutThisTask,
              priorityId: this.formAddTask.taskPriorityId,
              repeatTaskInterval: daysCount || null,
              recuringCount: !this.formAddTask.reocuringCount ? -1 : this.formAddTask.reocuringCounter,
              leaderCompanyUserId: this.formAddTask.assignedToId || null,
              businessUnitId: this.formAddTask.businessUnitId,
              hasProgress: this.formAddTask.progressNote,
              allowExternalNotifications: this.formAddTask.allowExternalNotification,
              companyClientPersonIdList: this.formAddTask.clientsId,
              companyVendorPersonIdList: this.formAddTask.vendorsId,
              // taskTypeId: this.formAddTask.typeTaskId,
              companyUserIdList: this.formAddTask.taskTeamId,
              reoccuringStartDate: startDay || null,
              addTaskDocument: this.formAddTask.addTaskDocuments,
              // DM
              sopId: this.formAddTask.sopListId,
              policyId: this.formAddTask.policyListId,
              healthsafetyId: this.formAddTask.healthSafetyListId,
              riskAssesmentId: this.formAddTask.riskAssesmentListId,
              envirenmentalId: this.formAddTask.envirenmentalListId,

              deadline: this.formAddTask.deadline,
              endedDate: this.formAddTask.endedDate,

              companyStageId: this.formAddTask.companyStageId,
              plannedStartDate: this.formAddTask.plannedStartDate,
              reviewDate: this.formAddTask.reviewDate,
            }
            axios
              .post(`/api/v1/engagementTasks/update?companyId=${this.$route.query.companyId}&engagementId=${this.$route.query.engagementId}&engagementTaskId=${this.selectedRow.id}`, data)
              .then(response => {
                this.$emit('submit', Number(this.$route.query.engagementId) ,'created', Number(this.$route.query.taskId), this.formAddTask.reoccuringTask)
                this.notification("Success", "Edit task", "success");
                loader.hide()
                this.$refs.addTask.close();
                if (this.$refs.editor.uploadedImagesArray.length) {
                  this.$store.dispatch('approveUploadedImages', {
                    fileUrlArr: this.$refs.editor.uploadedImagesArray,
                    entityId: this.selectedRow.id,
                    entityTypeId: 34 // eng task about entity
                  })
                }
                if (this.$refs.editor.removedImages.length) {
                  this.$store.dispatch('deleteRemovedImages', this.$refs.editor.removedImages)
                }
                // let id = this.$route.query.engagementId
                // this.newCreatedEngagementTask = response.data.projectTaskId
                // this.setEngagementRowData(id ,'created')
              })
              .catch(error => {
                // Handle error.
                // this.notification("Notification", error.response.data.message, "info")
                loader.hide()
              });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      modalCancel(ref) {
        this.$refs[ref].close();
      },
      closeTaskModal(){
        this.formAddTask.typeTask = ''
        this.formAddTask.typeTaskId = ''
        this.formAddTask.functionTaskId = ''
        this.formAddTask.functionTask = []
        this.formAddTask.aboutThisTask = ''
        this.formAddTask.taskTeamId = []
        this.formAddTask.daysCount = 1
        this.formAddTask.progressNote = false
        this.formAddTask.allowExternalNotification = false
        this.formAddTask.startDay = ''
        this.formAddTask.vendorsId = []
        this.formAddTask.clientsId = []
        this.formAddTask.assignedToId = null
        this.formAddTask.assignedTo = []
        this.formAddTask.envirenmentalList = []
        this.formAddTask.healthSafetyList = []
        this.formAddTask.policyList = []
        this.formAddTask.riskAssesmentList = []
        this.formAddTask.sopList = []
        this.formAddTask.taskTeam = []
        this.formAddTask.taskPriority = []
        this.editDisabled = false
        this.isEditActivated = false

        this.formAddTask.sopListId = null
        this.formAddTask.policyListId = null
        this.formAddTask.healthSafetyListId = null
        this.formAddTask.riskAssesmentListId = null
        this.formAddTask.envirenmentalListId = null
        this.formAddTask.addTaskDocuments = false

        this.companyUserList = []
        this.businessUnits = []
        this.newClientList = []

        this.$refs['formAddTask'].resetFields()

        this.formAddTask.deadline = false
        this.formAddTask.endedDate = null
        this.taskStatus = 1
        this.minimumDate = null
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
    },
    watch:{
      reoccuringTask(val){
        if (val){
          this.formAddTask.progressNote = true;
          this.addProgDisabled = true
        }else{
          this.formAddTask.progressNote = false;
          this.addProgDisabled = false
        }
      },
      'formAddTask.deadline'(val) {
        if (!val) {
          this.formAddTask.endedDate = null
          this.formAddTask.progressNote = false;
          this.addProgDisabled = false
        } else {
          this.formAddTask.progressNote = true;
          this.addProgDisabled = true
        }
      },
    }
  }
</script>

<style scoped lang="less">
    .demo-ruleForm{
        text-align:left;
    }
    .input-recuring-counter{
        width:50px;
    }
    .btn-wrap{
        position:relative;
        .star{
            color:#F56C6C;
            position:absolute;
            left: -20px;
            font-size:19px !important;
            font-weight:inherit;
        }
    }
    .repeat{
        width:100px;
    }
    .datepicker{
        width:100px;
    }
    .flex-end{
        display:flex;
        justify-content: flex-end;
    }
    // tree select
    /deep/.vue-treeselect__control{
        background-color: transparent;
        background-image: none;
        border: none;
        border-bottom: 1px solid rgba(0, 0, 0, 0.5);
        color: black;
        font-size: inherit;
        border-radius: 0;
        padding: 0 15px 0 0;
        -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
        transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
        width: 100%;
    }
    .aboutButton{
      display: flex;
      justify-content: center;
      margin-bottom: 18px;
    }
</style>
